"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DELTA_DISTANCE_FOR_MOM_TO_SVG = exports.ASSUMED_SVG_CENTER = exports.MINIMUM_DEVIATION_THRESHOLD = exports.DEFAULT_DELTA_DISTANCE = void 0;
exports.DEFAULT_DELTA_DISTANCE = 40000;
exports.MINIMUM_DEVIATION_THRESHOLD = 8; // unit in centimeters
exports.ASSUMED_SVG_CENTER = [500, 500];
exports.DELTA_DISTANCE_FOR_MOM_TO_SVG = 8000;
